import { computed, Directive, input } from '@angular/core';
import { BadgeVariantProps, badgeVariants } from './badge.variants';

@Directive({
  selector: 'span[libBadge], code[libBadge]',
  host: {
    '[class]': 'classes()',
  },
})
export class BadgeDirective {
  public readonly variant = input<BadgeVariantProps['variant']>('muted');
  public readonly size = input<BadgeVariantProps['size']>('sm');
  public readonly class = input('');

  protected readonly classes = computed(() =>
    [
      badgeVariants({
        variant: this.variant(),
        size: this.size(),
      }),
      this.class(),
    ]
      .filter(Boolean)
      .join(' ')
  );
}
